import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { meta } from "../../src/landingPage/datasets/meta";
import { CreditBureau } from "../../src/landingPage/views/Usecases/CreditBureau/CreditBureau";

const CreditBureauPage = () => {
  return (
    <>
      <NextHead
        currentPath="/use-cases/credit-bureau-consolidation"
        title={meta.usecases.creditbureau.title}
        description={meta.usecases.creditbureau.description}
      />
      <CreditBureau />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default CreditBureauPage;
